import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import LoggedInLayout from '../components/LoggedInLayout';
import { hideError } from '../actions/LayoutActions';
import { RouteComponentProps } from 'react-router';
import { updateUserAutheticatedInfo, logoutAsyncThunk } from '../../Auth/actions/AuthActions';
import { ReactNode } from 'react';


const mapStateToProps = (state: RootState) => ({
    showError: state.layoutRdc.showError,
    errorMessage: state.layoutRdc.errorMessage,
    username: state.authRdc.userDisplayName,
    isAuthenticated: state.authRdc.isAuthenticated,
    checkTokenBusy: state.authRdc.refreshTokenBusy
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        hideError: () => {
            dispatch(hideError())
        },
        onFirebaseAuthChange: (isAutheticated: boolean) => {
            dispatch(updateUserAutheticatedInfo(isAutheticated))
        },
        logout: async () => {
            await dispatch(logoutAsyncThunk())
        }
    })
}

export type LoggedInLayoutProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any> & {children: ReactNode}

const LayoutCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoggedInLayout);

export default LayoutCnn